import { z } from 'zod';

// Project validation schemas
export const createProjectSchema = z.object({
  name: z.string().min(1, 'Project name is required'),
  organizationId: z.string().min(1, 'Organization ID is required'),
  description: z.string().optional(),
  environment: z.enum(['development', 'staging', 'production']).optional(),
  region: z.string().optional(),
  settings: z
    .object({
      maxStreams: z.number().int().min(1).optional(),
      maxUsers: z.number().int().min(1).optional(),
      storageGB: z.number().int().min(1).optional(),
      retentionDays: z.number().int().min(1).optional(),
      features: z.array(z.string()).optional(),
    })
    .optional(),
});

export const updateProjectSchema = z.object({
  name: z.string().min(1).optional(),
  enabled: z.boolean().optional(),
  description: z.string().optional(),
  environment: z.enum(['development', 'staging', 'production']).optional(),
  region: z.string().optional(),
  settings: z
    .object({
      maxStreams: z.number().int().min(1).optional(),
      maxUsers: z.number().int().min(1).optional(),
      storageGB: z.number().int().min(1).optional(),
      retentionDays: z.number().int().min(1).optional(),
      features: z.array(z.string()).optional(),
    })
    .optional(),
});

// Type exports derived from schemas
export type CreateProjectRequest = z.infer<typeof createProjectSchema>;
export type UpdateProjectRequest = z.infer<typeof updateProjectSchema>;
